import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import FeedbackComp from './FeedbackComp'

function Feedback() {
    return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Feeback</h1>
                    <NavBar />
                </div>
                <FeedbackComp />
            </div>
        </div>
    )
}

export default Feedback